import React from "react";
import { ProviderIcon } from "../../shared/ProviderIcon";
import { PROVIDER_ORDER, toPayloadProvider } from "./providerMap";
import { tierOf } from "./tierColors";

const SEGMENT_CLASS = {
	3: "monitoring__analysis-strategy-coverage-segment--3",
	2: "monitoring__analysis-strategy-coverage-segment--2",
	1: "monitoring__analysis-strategy-coverage-segment--1",
	0: "monitoring__analysis-strategy-coverage-segment--0",
};

export default function CoverageBar({ impact, showIcons = true, showLabel = true }) {
	const coverage = impact?.coverage ?? 0;
	const tier = tierOf(coverage);

	return (
		<div className="monitoring__analysis-strategy-coverage-inline">
			{showIcons && (
				<div className="monitoring__analysis-strategy-impact-icons">
					{PROVIDER_ORDER.map((p) => (
						<ProviderIcon
							key={p}
							provider={p}
							size={14}
							className={
								impact?.[toPayloadProvider(p)]
									? ""
									: "monitoring__analysis-strategy-impact-dim"
							}
						/>
					))}
				</div>
			)}
			<div className="monitoring__analysis-strategy-coverage-bar-inline" aria-hidden>
				{PROVIDER_ORDER.map((p) => (
					<span
						key={p}
						className={`monitoring__analysis-strategy-coverage-segment ${
							impact?.[toPayloadProvider(p)]
								? SEGMENT_CLASS[tier]
								: SEGMENT_CLASS[0]
						}`}
					/>
				))}
			</div>
			{showLabel && (
				<span className="monitoring__analysis-strategy-impact-count">{coverage}/3</span>
			)}
		</div>
	);
}
